import React, { useState, useEffect, useContext, Fragment } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import { useParams, Link, useHistory } from 'react-router-dom';
import axios from '../../../../../api/axios';
import MainContext from '../../../../../store/MainContext';
import Loading from '../../../../../components/OtherElements/Loading';
import AccessDenied from '../../../../../components/OtherElements/AccessDenied';
import { actionList } from '../../../../../config';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import TextFeild from '@material-ui/core/TextField';
import useTitle from 'hooks/useTitle';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  cancelContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'flex-start',
    '&>div': {
      marginBottom: theme.spacing(1),
    },
  },
  buttons: {
    display: 'flex',
    flexFlow: 'row nowrap',
    '&>button:not(:nth-child(1))': {
      marginLeft: theme.spacing(1),
    },
    '&>button': {
      color: '#fff',
    },
  },
  accept: {
    background: green[500],
  },
  cancel: {
    background: red[500],
  },
}));

const Rejected = () => {
  useTitle('رد بار');
  const classes = useStyles();
  const accessName = 'rejected';
  const { state, dispatch, showMessage, showError } = useContext(MainContext);
  // const { itemsCountPerPage } = state.Props;
  const history = useHistory();
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const getOrder = async () => {
    try {
      const { data } = await axios.get(`/api/v1/admin/order/${id}`);
      data && setOrder(data);
    } catch (error) {
      showError(error);
    }
  };
  const logout = () => {
    showError('عدم رعایت سیکل سفارش. دسترسی غیرقانونی شناسایی شد.');
    dispatch({ type: 'AUTH', action: 'LOGOUT' });
  };
  const handleBack = () => {
    history.replace(`/protected/admin/orders/${order._id}`);
  };
  const handleRejectOrder = async () => {
    try {
      setLoading(true);
      const { data } = await axios.post(`/api/v1/admin/order/rejected`, {
        orderId: order._id,
        reason: reason ? reason : 'دلیل توضیح داده نشده است.',
      });
      showMessage(data.messages);
      history.replace(`/protected/admin/orders/${order._id}`);
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    let { value } = e.target;
    setReason(value);
  };

  useEffect(() => {
    getOrder();
  }, []);

  useEffect(() => {
    order && !actionList[order.status].includes(accessName) && logout();
  }, [order]);

  return (
    <Fragment>
      {!!order ? (
        <Fragment>
          {actionList[order.status].includes(accessName) ? (
            <FullCard
              title="رد بار"
              category="زمانیکه بنابه دلایلی میخواهید بصورت کلی سفارش را رد کنید. صاحب بار و رانندگان دیگر قادر به تغییر نخواهند بود"
            >
              <div className={classes.cancelContainer}>
                <div>
                  آیا از رد بار شماره رهگیری: {order.tracingCode} اطمینان دارید؟
                </div>
                <TextFeild
                  variant="outlined"
                  style={{ width: 350 }}
                  size="medium"
                  multiline
                  rows={4}
                  label="دلایل رد بار را توضیح دهید"
                  onChange={handleChange}
                  value={reason}
                />
                <div className={classes.buttons}>
                  <Button
                    variant="contained"
                    size="large"
                    className={classes.accept}
                    onClick={handleRejectOrder}
                    disabled={loading}
                    endIcon={loading ? <CircularProgress size={10} /> : <></>}
                  >
                    بله اطمینان دارم!
                  </Button>
                  <Button
                    variant="contained"
                    size="large"
                    className={classes.cancel}
                    onClick={handleBack}
                  >
                    خیر - بازگشت
                  </Button>
                </div>
              </div>
            </FullCard>
          ) : (
            <AccessDenied />
          )}
        </Fragment>
      ) : (
        <Loading text="درحال بررسی سفارش ..." />
      )}
    </Fragment>
  );
};

export default React.memo(Rejected);
